import React from 'react';
import { CloseIcon } from 'src/assets/images';
import { QuantitySpinInput } from 'src/features/common';
import './basket-entry.scss';

export type BasketEntryProps = {
  image: string;
  title: string;
  price: number;
  min: number;
  max: number;
  priceString: string;
  priceSuffix: string;
  onRemove: () => void;
  [key: string]: any;
};

export const BasketEntry = ({
  image,
  title,
  min,
  max,
  priceString,
  priceSuffix,
  onRemove,
  ...props
}: BasketEntryProps) => {
  return (
    <section className="basket-entry-container">
      <aside className="is-hidden-mobile">
        <img src={image} alt="Icon" className="product-image" />
      </aside>
      <p className="basket-entry-title">{title}</p>
      {props['field'] && (
        <QuantitySpinInput
          lightMode
          automationid={props.automationId}
          min={min}
          max={max}
          name={props?.field?.name}
          {...props}
        />
      )}
      <p className="basket-entry-price">
        {priceString && priceString}
        {priceSuffix && <mark>{' ' + priceSuffix}</mark>}
      </p>
      <img
        src={CloseIcon}
        alt="X"
        className="remove-button"
        onClick={onRemove}
        automationid={`${props.automationid}_Remove`}
      />
    </section>
  );
};
